import React, { useState } from "react";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import {
  // Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Input,
  Label,
} from "components/ui";
import {
  AddTemplatesAction,
  UpdateTemplatesAction,
} from "store/middlewares/dataManagement/messageTemplate";
import { InputTextarea, SubmitLoaderButton } from "components/atoms";

function ModalEditMessageTemplate({ row }) {
  const dispatch = useDispatch();
  const [formError, setFormError] = useState(false);

  //--------------------- image change function ------------------------------
  const [selectedImage, setSelectedImage] = useState(row?.image_url || null);
  const [imageError, setImageError] = useState("");

  const { settings } = useSelector((state) => state.settings);
  const handleSubmit = (values) => {
    let tempObj = { ...values, title: values.title.trim() };

    if (row) {
      tempObj = {
        ...tempObj,
        id: row?.id,
        image: values.type === "followUp" ? null : values.image,onSuccess: () => formik.setSubmitting(false),
    onError: () => {
      setFormError(true);
      formik.setSubmitting(false);
    },
      };
      dispatch(UpdateTemplatesAction(tempObj));
    } else {
      dispatch(AddTemplatesAction(tempObj));
    }
  };

  const handleImageChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const maxSizeMb = settings?.upload_image_size ?? 5;
    const maxSize = maxSizeMb * 1024 * 1024;

    setImageError("");
    setSelectedImage("");

    if (file.size > maxSize) {
      setImageError(`Please upload image smaller than ${maxSizeMb}MB.`);
      formik.setFieldValue("image", null);
      event.target.value = "";
      return;
    }

    const objectUrl = URL.createObjectURL(file);
    const img = new Image();

    img.onload = () => {
      formik.setFieldValue("image", file);
      setSelectedImage(objectUrl);
    };

    img.onerror = () => {
      setImageError(
        "The selected image is corrupted. Please upload a valid image file.",
      );
      setSelectedImage(null);
      formik.setFieldValue("image", null);
      URL.revokeObjectURL(objectUrl);
      event.target.value = "";
    };

    img.src = objectUrl;
  };

  const formik = useFormik({
    initialValues: {
      title: row?.title ? row?.title : "",
      content: row?.content ? row?.content : "",
      type: "message",
      image: row?.image || "",
    },
    validationSchema: Yup.object({
      title: Yup.string()
        .required("Title is required")
        .min(3, "Minimum 3 characters required"),
      content: Yup.string()
        .required("Content is required")
        .min(3, "Minimum 3 characters required"),
      image: Yup.mixed().required("Image is required"),
    }),
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="grid gap-5 lg:gap-7.5 mx-auto">
        <Card className="min-w-full">
          <CardHeader>
            <CardTitle>Message Templates</CardTitle>
          </CardHeader>
          <CardContent className="grid gap-5">
            <div className="flex items-baseline flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-32">Title</Label>
              <Input
                error={formik.errors.title && formik.touched.title}
                errorMsg={formik.errors.title}
                value={formik.values.title}
                type="text"
                name="title"
                isSpace={true}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                placeholder="Enter title"
                className={"!py-0 w-full"}
                maxLength={50}
              />
            </div>
            <div className="flex items-start flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-32 mt-4">Content</Label>
              <InputTextarea
                error={formik.errors.content && formik.touched.content}
                errorMsg={formik.errors.content}
                value={formik.values.content}
                type="text"
                name="content"
                isSpace={true}
                isRequired={false}
                onChange={(e) => {
                  if (e.target.value.length <= 150) {
                    formik.handleChange(e);
                  }
                }}
                onBlur={formik.handleBlur}
                placeholder="Enter content"
                maxLength={150}
              />
            </div>

            <div className="flex items-start flex-wrap lg:flex-nowrap gap-2.5">
              <Label className="flex w-full max-w-32 mt-4">Image</Label>

              <div className="w-full">
                <input
                  type="file"
                  name="image"
                  accept="image/jpeg,image/jpg,image/png"
                  className="block w-full text-sm border rounded file:mr-3 file:py-2 file:px-3 file:border-0 file:bg-gray-100 file:cursor-pointer"
                  onChange={(e) => {
                    formik.setFieldTouched("image", true);
                    handleImageChange(e);
                  }}
                />

                {imageError && (
                  <div className="text-[0.8125rem] text-red-500 mt-1">
                    {imageError}
                  </div>
                )}
                {!imageError && formik.errors.image && formik.touched.image && (
                  <div className="text-[0.8125rem] text-red-500 mt-1">
                    {formik.errors.image}
                  </div>
                )}
                {(selectedImage || row?.image_url) && !imageError && (
                  <img
                    src={selectedImage || row.image_url}
                    alt="template"
                    className="mt-3 w-24 h-24 object-cover rounded"
                  />
                )}
              </div>
            </div>

            <div className="flex justify-center">
              {/* <Button type={"submit"}>{row ? "Update" : "Add"}</Button> */}
             <SubmitLoaderButton
                 btnText={row ? "Update" : "Add"}
                isDisable={formik.isSubmitting && !formError}      
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </form>
  );
}

export default ModalEditMessageTemplate;
